import dayjs from "../../util/dayjs"

export type Option = {
  value: string,
  name: string,
}

export const sortOptions: Option[] = [
  { value: "created_desc", name: "投稿日が新しい順" },
  { value: "created_asc", name: "投稿日が古い順" },
  { value: "comment_desc", name: "コメントが多い順" },
  { value: "comment_asc", name: "コメントが少ない順" },
]

export const voteOpenOptions: Option[] = [
  { value: "", name: "リセット" },
  { value: "true", name: "開催中" },
  { value: "false", name: "終了" },
]

export const formatEventDate = (start_date: any, end_date: any) => {
  const startDate = dayjs(start_date);
  const endDate = dayjs(end_date);

  if (startDate.isSame(endDate, "day")) {
    // If start and end dates are the same
    return startDate.format("YYYY年M月D日(ddd)");
  } else {
    // If start and end dates are different
    return `${startDate.format("YYYY年M月D日(ddd)")}~${endDate.format(
      "M月D日(ddd)"
    )}`;
  }
};
